import Vue from "vue";
import {
  Row,
  Col,
  Pagination,
  Spin, 
  Button, 
  Input, 
  Menu, 
  Form,
  FormModel,
  DatePicker, 
  Tabs, 
  Radio, 
  Select, 
  Modal,
  Carousel,
  Icon,
  Checkbox,
  Message,
  Notification
} from "ant-design-vue";

export default () => {
  let els = [
    Row,
    Col,
    Pagination,
    Spin, 
    Button, 
    Input, 
    Menu, 
    Form,
    FormModel,
    DatePicker, 
    Tabs, 
    Radio, 
    Select, 
    Modal,
    Carousel,
    Icon,
    Checkbox,
  ];
  // 注册
  els.forEach((item) => {
    Vue.use(item);
  })

  Vue.prototype.$notification = Notification;
  Vue.prototype.$message = Message;
  Vue.prototype.$confirm = Modal.confirm;
}

